import React, { useEffect, useRef, useState } from 'react'
import OffcialLogoSvg from '../assets/svg/OffcialLogoSvg'
import { StyledLink, StyledLinkFooter, StyledLinkGreyNoHover } from '../components/StyledLink';
import Globe18pxSvg from '../assets/images/icons/svg/Globe18pxSvg';
import ChevronDownThick16pxSvg from '../assets/images/icons/svg/ChevronDownThick16pxSvg';
import { StyledLinkGreyHoverBlue } from './../components/StyledLink';
import Location20pxSvg from './../assets/images/icons/svg/Location20pxSvg';
import PhoneRing20pxSvg from './../assets/images/icons/svg/PhoneRing20pxSvg';
import Info20pxSvg from './../assets/images/icons/svg/Info20pxSvg';
import { useTranslation } from 'react-i18next';
import i18n from './../n18i';
import { useDispatch } from 'react-redux'
import { changeLanguage } from '../redux/language/reducer';
import { Popper, ClickAwayListener, MenuItem, Link, Grow, MenuList } from '@mui/material';
import { FooterLanguagePaper } from '../components/StyledComponents';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const { t } = useTranslation()

  useEffect(() => {
    if (localStorage.getItem("i18nextLng")?.length > 2) {
      i18n.changeLanguage("vi");
    }
  }, [])

  const dispatch = useDispatch();

  const handleChangeLanguage = (language) => {
    switch (language) {
      case "en":
        i18n.changeLanguage("en");
        dispatch(changeLanguage(language));
        setOpenLanguage(false)
        break;
      case "vi":
        i18n.changeLanguage("vi");
        dispatch(changeLanguage(language));
        setOpenLanguage(false)
        break;
      default:
        break;
    }
  };

  const handleListKeyDown = (event) => {
    if (event.key === 'Escape') {
      setOpenLanguage(false);
    }
  }

  const [openLanguage, setOpenLanguage] = useState(false)

  const handleToggleLanguage = () => {
    setOpenLanguage(!openLanguage);
  }

  const anchorRefLanguage = useRef(null)

  const handleCloseLanguage = (event) => {
    if (anchorRefLanguage.current && anchorRefLanguage.current.contains(event.target)) {
      return;
    }
    setOpenLanguage(false)
  }

  return (
    <div className='footer w-full bg-primary text-sm'>
      <div className='container'>
        <div className='grid grid-cols-12 lg:grid-cols-9 py-10 md:py-20 gap-x-5 gap-y-5'>
          <div className='col-span-12 md:col-span-6 lg:col-span-3'>
            <p className='text-white font-bold'>{t('public.solutions')}</p>
            <ul>
              <li><StyledLinkGreyHoverBlue>{t('public.custom-design-and-manufacturing')}</StyledLinkGreyHoverBlue></li>
              <li><StyledLinkGreyHoverBlue>{t('public.smart-parcels-tracking-seegale-solution')}</StyledLinkGreyHoverBlue></li>
              <li><StyledLinkGreyHoverBlue>{t('public.smart-glass-rack-tracking-solution')}</StyledLinkGreyHoverBlue></li>
              <li><StyledLinkGreyHoverBlue>{t('public.returnable-asset-tracking-for-logistics')}</StyledLinkGreyHoverBlue></li>
              <li className='xl:pr-10'><StyledLinkGreyHoverBlue>{t('public.indoor-air-quality-and-energy-efficiency-solution')}</StyledLinkGreyHoverBlue></li>
              <li><StyledLinkGreyHoverBlue>{t('public.green-buildings-solution')}</StyledLinkGreyHoverBlue></li>
            </ul>
          </div>
          <div className='col-span-12 md:col-span-6 lg:col-span-2'>
            <p className='text-white font-bold'>{t('public.products')}</p>
            <ul>
              <li><StyledLinkGreyHoverBlue>{t('public.mrconnect-data-platform')}</StyledLinkGreyHoverBlue></li>
              <li><StyledLinkGreyHoverBlue>{t('public.mrtag-asset-management')}</StyledLinkGreyHoverBlue></li>
              <li><StyledLinkGreyHoverBlue>{t('public.ready-to-use-products')}</StyledLinkGreyHoverBlue></li>
            </ul>
          </div>
          <div className='col-span-12 md:col-span-6 lg:col-span-2'>
            <p className='text-white font-bold'>{t('public.iot-connectivity')}</p>
            <ul>
              <li><StyledLinkGreyHoverBlue>{t('public.sigfox')}</StyledLinkGreyHoverBlue></li>
              <li><StyledLinkGreyHoverBlue>{t('public.lorawan')}</StyledLinkGreyHoverBlue></li>
              <li><StyledLinkGreyHoverBlue>{t('public.global-cellular-connectivity')}</StyledLinkGreyHoverBlue></li>
              <li><StyledLinkGreyHoverBlue>{t('public.satellite')}</StyledLinkGreyHoverBlue></li>
            </ul>
          </div>
          <div className='col-span-12 md:col-span-6 lg:col-span-2'>
            <p className='text-white font-bold'>{t('public.contact-us')}</p>
            <ul>
              <li>
                <div className='flex gap-2'>
                  <div>
                    <Location20pxSvg />
                  </div>
                  <p className='text-grey-primary pr-5'>{t('public.address')}</p>
                </div>
              </li>
              <li>
                <div className='flex gap-2 '>
                  <div>
                    <PhoneRing20pxSvg />
                  </div>
                  <p className='text-grey-primary'>1900 6884<br />
                    +84 28 3636 6015</p>
                </div>
              </li>
              <li>
                <div className='flex gap-2'>
                  <div>
                    <Info20pxSvg />
                  </div>
                  <p className='text-grey-primary'><StyledLinkGreyNoHover href="mailto:info@mobile-id.vn">info@mobile-id.vn</StyledLinkGreyNoHover></p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className='h-[1px] bg-[#ffffff14]'></div>
      <div className='container'>
        <div className='py-7 flex flex-wrap justify-between items-center gap-5'>
          <div className='flex flex-col gap-3'>
            <OffcialLogoSvg />
            <p className='text-[#ffffff4d]'>Copyright © {currentYear} <StyledLink className='!text-[#ffffff4d]' href="https://www.mobile-id.vn/" target='_blank'>Mobile-ID</StyledLink></p>
          </div>
          <div className='flex flex-wrap gap-3 items-center'>
            <div>
              <StyledLinkFooter>{t('public.privacy-policy')}</StyledLinkFooter>
            </div>
            <div>
              <StyledLinkFooter>{t('public.terms-of-service')}</StyledLinkFooter>
            </div>
            <div>
              <StyledLinkFooter>{t('public.faq')}</StyledLinkFooter>
            </div>
            <div>
              <StyledLinkFooter>{t('public.support')}</StyledLinkFooter>
            </div>
            <div>
              <StyledLinkFooter className={`!border-r-0 ${openLanguage ? "open" : ""}`}
                onClick={handleToggleLanguage}
                ref={anchorRefLanguage}
                id="navbar-language-button"
                aria-controls={openLanguage ? 'navbar-language-menu' : undefined}
                aria-expanded={openLanguage ? 'true' : undefined}
                aria-haspopup="true"
              >
                <Globe18pxSvg />
                <p>{localStorage.getItem("i18nextLng") === "en" ? "English" : "Việt Nam"}</p>
                <ChevronDownThick16pxSvg />
              </StyledLinkFooter>
              <div>
                <Popper
                  open={openLanguage}
                  anchorEl={anchorRefLanguage.current}
                  role={undefined}
                  placement="top-start"
                  transition
                  disablePortal
                  className='z-10'
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === 'top-end' ? 'left top' : 'left bottom',
                      }}
                    >
                      <FooterLanguagePaper>
                        <ClickAwayListener onClickAway={handleCloseLanguage}>
                          <MenuList
                            id="navbar-language-menu"
                            aria-labelledby="navbar-language-button"
                            onKeyDown={handleListKeyDown}
                          >
                            <MenuItem>
                              <Link onClick={() => { handleChangeLanguage("en") }}>English</Link>
                            </MenuItem>
                            <div className='px-5'>
                              <div className='h-[1px] bg-[#ffffff4d] px-5'></div>
                            </div>
                            <MenuItem >
                              <Link onClick={() => { handleChangeLanguage("vi") }}>Việt Nam</Link>
                            </MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </FooterLanguagePaper>
                    </Grow>
                  )}
                </Popper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer